(function() {
    'use strict';

    angular
        .module('app')
        .config([
            '$routeProvider', function($routeProvider) {
                $routeProvider
                    .when('/login',
                        {
                            templateUrl: 'assets/login/login.html',
                            controller: 'LoginController',
                            controllerAs: 'vm'
                        });
            }
        ])
        .controller('LoginController', loginController);

    loginController.$inject = ['$location', '$sessionStorage', 'authService'];

    function loginController($location, $sessionStorage, authService) {
        var vm = this;
        angular.extend(vm, {
            $sessionStorage: $sessionStorage,
            isLoading: true,
            isAnonymousLoginAllowed: false,
            loginDone: false,
            error: '',
            agencies: {},
            selectedAgency: '',
            loginFormSubmit: function () {
                vm.error = '';
                if (!vm.username || !vm.password) {
                    // no validation for anonymous user (as guest)
                    if (!vm.isAnonymousLoginAllowed) {
                        vm.error = 'Username or password must not be empty.';
                    }

                    return;
                }
                authService.login(vm.username, vm.password)
                    .then(function (resp) {
                        if (resp.d.authenticated) {
                            vm.loginDone = true;
                            vm.agencies = resp.d.agencies;
                            if (vm.agencies) vm.selectedAgency = vm.agencies[0];
                            if (vm.agencies && vm.agencies.length === 1) {
                                vm.agencyFormSubmit();
                            }
                        } else {
                            vm.error = resp.d.error;
                        }
                    }).catch(function (e) {
                        var message = e;
                        if (e.data && (e.data.Message || e.status)) {
                            message = 'Server error: ' + (e.data.Message || e.status);
                        }

                        vm.error = 'Error: ' + message;
                    });
            },
            agencyFormSubmit: function () {
                if (!vm.selectedAgency) {
                    return;
                }

                // put agency in session scope
                $sessionStorage.logonInfo.agency = vm.selectedAgency;
                vm.password = '';
                var whereTo = $location.search().returnTo;
                $location.search('returnTo', null);
                $location.path(whereTo || "/");
            },
            cancelLogin: function () {
                authService.logout();
                vm.selectedAgency = '';
                vm.loginDone = false;
                vm.error = '';
                vm.username = '';
                vm.password = '';
            },
            loginAsGuest: function () {
                vm.loginDone = true;
                authService.login(null, null)
                    .then(function (resp) {
                        if (resp.d.authenticated) {
                            vm.loginDone = true;
                            vm.agencies = resp.d.agencies;
                            if (vm.agencies) {
                                vm.selectedAgency = vm.agencies[0];
                                vm.agencyFormSubmit();
                            }
                        } else {
                            vm.error = resp.d.error;
                        }
                    }).catch(function (e) {
                        var message = e;
                        if (e.data && (e.data.Message || e.status)) {
                            message = 'Server error: ' + (e.data.Message || e.status);
                        }

                        vm.error = 'Error: ' + message;
                    });
            },
            loginUsingTicket: function (ticketId) {
                vm.loginDone = true;
                authService.loginUsingTicket(ticketId)
                    .then(function (resp) {
                        if (resp.d.authenticated) {
                            vm.loginDone = true;
                            vm.agencies = resp.d.agencies;
                            if (vm.agencies) {
                                vm.selectedAgency = vm.agencies[0];
                                vm.agencyFormSubmit();
                            }
                        } else {
                            vm.error = resp.d.error;
                        }
                    }).catch(function (e) {
                        var message = e;
                        if (e.data && (e.data.Message || e.status)) {
                            message = 'Server error: ' + (e.data.Message || e.status);
                        }

                        vm.error = 'Error: ' + message;
                    });
            },
            searchArgs: $location.absUrl().indexOf('?') !== -1
                ? _.chain($location.absUrl().split('?').pop())
                    .split('&')
                    .map(_.ary(_.partial(_.split, _, '='), 1))
                    .fromPairs()
                    .value()
                : ''
        });

        if (!$sessionStorage.logonInfo) {
            authService.retrieveEnvironment()
                .then(function () {
                    vm.isLoading = false;
                    vm.brandHeaderLink = $sessionStorage.environment.brandHeaderLink;
                    // ticketId = '20a5bc0e-2dc2-4bc1-80e9-9ff9cd32f8c2';
                    if (vm.searchArgs.ticketId) {
                        vm.loginUsingTicket(vm.searchArgs.ticketId);
                    }
                    // anonymous mode on server = no login needed
                    else if ($sessionStorage.environment.isAnonymousLoginAllowed) {
                        vm.isAnonymousModeEnabled = true;
                        vm.loginAsGuest();
                    }
                }).catch(function (e) {
                    vm.isLoading = false;
                    var message = e;
                    if (e.data && (e.data.Message || e.status)) {
                        message = 'Server error: ' + (e.data.Message || e.status);
                    }

                    vm.error = 'Error: ' + message;
                });
        }
        else {
            vm.isLoading = false;
            vm.isAnonymousLoginAllowed = $sessionStorage.environment.isAnonymousLoginAllowed;
        }
    }
})();


// WEBPACK FOOTER //
// ./src/login/login.controller.js